export default __webpack_public_path__ + "folder-white-shape.png";